import {
  MouseEvent,
  ComponentProps,
  ComponentType,
  ReactNode,
} from 'react';
import {
  Page as SharedPage,
} from '@equifinance/shared';
import Header from '../Header';

export default function Page({
  subHeader,
  InnerContentContainer,
  sidebar,
  sidebarFooter,
  onClickLogo,
  children,
}: {
  subHeader?: ReactNode,
  InnerContentContainer?: ComponentType<ComponentProps<'div'>>,
  sidebar?: ReactNode,
  sidebarFooter?: ReactNode,
  onClickLogo?: (event?: MouseEvent<HTMLElement>) => void,
  children: ReactNode
}) {
  return (
    <SharedPage
      header={<Header onClickLogo={onClickLogo} />}
      subHeader={subHeader}
      InnerContentContainer={InnerContentContainer}
      sidebar={sidebar}
      sidebarFooter={sidebarFooter}
    >
      {children}
    </SharedPage>
  );
}
